import * as rum from '@maui-mf/analytics-datadog-rum'
import { initTracker } from './utils'

export const init = () => {
  initTracker('datadog-rum', rum)
}
